import Swiper from 'swiper/dist/js/swiper';
 

 new Swiper("#slider__menu", {

    spaceBetween: 20,
    slidesPerView: 10,
    preventClicks: false,
    preventClicksPropagation: false,
    preloadImages: false,
    lazy: {
        preloaderClass: 'spinner-loading',
    },
    loop: false,
    allowTouchMove: true,
    navigation: {      
        nextEl: ".swiper__menu-btn-next ",
        prevEl: ".swiper__menu-btn-prev "
    },
    observer: true,
    breakpoints: {
      400: {
        slidesPerView: 4,   
        spaceBetween: 20
      },
        640: {
          slidesPerView: 6,   
          spaceBetween: 20
        },
        800: {   
            slidesPerView: 6,      
          spaceBetween: 40
        },
        1024: {
            slidesPerView: 'auto',
            spaceBetween: 15
        }
      }

});
